import { render, staticRenderFns } from "./SystemHealthScreen.vue?vue&type=template&id=ded75fd8&"
import script from "./SystemHealthScreen.vue?vue&type=script&lang=js&"
export * from "./SystemHealthScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports